import { StyleSheet } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  dropdownItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    gap: 16,
    borderBottomWidth: 1,
    borderColor: neutrals.neutralGrays.dust,
  },
  dropdownItemPressed: {
    backgroundColor: neutrals.coldGrays.ice,
  },
  dropdownItemHovered: {
    backgroundColor: neutrals.coldGrays.ice,
  },
  dropdownItemText: {
    fontSize: 12,
    fontWeight: '700',
    lineHeight: 13,
    letterSpacing: 0,
    color: neutrals.black,
  },
  dropdownItemTextSelected: {
    fontSize: 12,
    fontWeight: '700',
    lineHeight: 13,
    letterSpacing: 0,
    color: brand.main.water,
  },
  dropdownItemCount: {
    fontSize: 10,
    fontWeight: '400',
    lineHeight: 13,
    letterSpacing: 0,
    color: neutrals.black,
  },
  dropdownItemCountSelected: {
    fontSize: 10,
    fontWeight: '400',
    lineHeight: 13,
    letterSpacing: 0,
    color: brand.main.water,
  },
  dropdownItemIcon: {
    flex: 3,
    justifyContent: 'center',
    gap: 4,
  },
  dropdownItemWrapper: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  checkIcon: {
    flex: 1,
    width: 14,
    height: 14,
  },
});
